var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * DeltaUp component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconDeltaUp extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12 7.82764C11.8469 7.82764 11.6955 7.85901 11.555 7.91982C11.4178 7.97921 11.294 8.06547 11.1907 8.17345L4.16738 15.1967C4.00396 15.3602 3.95507 15.606 4.04351 15.8195C4.13196 16.033 4.34032 16.1723 4.57144 16.1723H19.4286C19.6597 16.1723 19.868 16.033 19.9565 15.8195C20.0449 15.606 19.9961 15.3602 19.8327 15.1967L12.8093 8.17345C12.7061 8.06547 12.5822 7.97921 12.445 7.91982C12.3045 7.85901 12.1531 7.82764 12 7.82764Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconDeltaUp.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconDeltaUp.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconDeltaUp.prototype, "size", void 0);
if (customElements.get('cat-icon-delta-up') === undefined) {
    customElements.define('cat-icon-delta-up', BlocksIconDeltaUp);
}
